import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import {InputTextCustom} from '../../../src/App'

const useStyles = makeStyles(theme => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: theme.spacing(1),
    },
  }));

export default function InputField(props) {
    const [labelWidth, setLabelWidth] = React.useState(0);
  const labelRef = React.useRef(null);
  const classes = useStyles();

  React.useEffect(() => {
    setLabelWidth(labelRef.current.offsetWidth);
  }, []);

    return (
        <div>
                <FormControl error={props.error} className={classes.formControl} variant={props.variant}>
                    <InputLabel
                    className = {props.classNamelabel}
                     ref={labelRef} htmlFor="component-outlined">
                     {props.label}
                    </InputLabel>
                    <InputTextCustom
                        endAdornment={props.endAdornment}
                        min={props.min}
                        variant="Standard"
                        id={props.id}
                        style={props.style}
                        error={props.error}
                        name={props.name}
                        className={props.className}
                        value={props.value}
                        onChange={props.onChange}
                        type={props.type}
                        autoComplete={props.autocomplete}
                        margin={props.margin}
                        required={props.required}
                        labelWidth={labelWidth}
                        disabled={props.disabled}
                        inputProps={props.inputProps}/>
                </FormControl>
        </div>
    );
}